<template>
	<b-modal
		centered
		:scrollable="scrollable"
		no-close-on-backdrop
		ref="modal"
		:size="size"
		:id="id"
		:modal-class="modalClass"
		:title="title"
		:hide-header="hideHeader"
		:hide-footer="hideFooter"
		:ok-title="okTitle"
		:ok-variant="okVariant"
		:ok-disabled="okDisabled"
		:busy="busy"
		:no-close-on-esc="busy"
		:hide-header-close="busy"
		:cancel-title="cancelTitle"
		:cancel-variant="cancelVariant"
		:ok-only="cancelTitle ? false: true"
		@ok="onSubmit"
		@cancel="$emit('cancel')"
		@show="$emit('show')"
		@shown="$emit('shown')"
		@hide="$emit('hide', $event)"
		@hidden="$emit('hidden')"
	>
		<slot/>
		<slot name="custom-footer"/>
		<!-- modal-footer 슬롯을 제공한 모달만 푸터 전체를 커스터마이즈 (미제공 시 기본 취소/확인 유지) -->
		<template v-if="$scopedSlots['modal-footer']" #modal-footer="scope">
			<slot name="modal-footer" v-bind="scope"/>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: 'ModalLayout',
	props: {
		busy: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		},
		size: {
			type: String,
			default: ''
		},
		hideHeader: {
			type: Boolean,
			default: false,
		},
		hideFooter: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			default: 'modal-layout'
		},
		okTitle: {
			type: String,
			default: '확인'
		},
		okVariant: {
			type: String,
			default: 'primary'
		},
		okDisabled: {
			type: Boolean,
			default: false,
		},	
		cancelTitle: {
			type: String,
			default: '취소'
		},
		cancelVariant: {
			type: String,
			default: 'light'
		},
		modalClass: {
			type: [String, Array, Object],
			default: null
		},
		scrollable: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		onSubmit(e) {
			e.preventDefault();
			this.$emit('submit', e)
		}
	}
}
</script>
